import { readContract } from "wagmi/actions";
import { type TokenDefinition, } from "@bracket/addressbook";
// import { ChainAddress, } from "@addresses";
import * as contracts from "@contracts";
import { getChainId, } from "./helpers";

import type { Address, ChainId, ExecutableToken, } from "@types";
import { getChainedToken } from "@bracket/addressbook";
import { wagmiConfig } from "@config";



export declare type AllowProps = {
	token: TokenDefinition;
	contract: string;
	chain?: ChainId,
}

export const allow = async ({
	token,
	contract,
	chain,
}: AllowProps ): Promise<bigint> => {

	try {
		chain = chain || getChainId();
		const result = await readContract(wagmiConfig, contracts.ERC20.allowCore({ token, contract, }));
		if( typeof result === "bigint" )  {
			return result;
		}
		throw new Error("allowance failed to produce a valid result");
	}
	catch ( err ) {
		throw new Error(`@bracket/stake-app :: resolver :: ${err instanceof Error ? err.message : "no error instance"}`);
	}
}
